import * as http from "./base";

export async function fetchMailPiecesDetailedCount(data) {
  return await http.post(`dashboard-service`, data);
}
